import React from "react";
import constants from "./constants";

const Link = (props) => {
  const defaultClasses = `text-${constants.primaryColorClass} hover:text-${constants.darkPrimaryColorClass} hover:underline`;

  return (
    <a {...props} className={`${defaultClasses} ${props.className}`}>
      {props.children}
    </a>
  );
};

export default Link;
